module.exports = __webpack_public_path__ + "img/contact-information.svg";